/**
 * Sector Repository
 */

import { apiClient } from '../../client'

import type { PaginatedResponse } from '../role.repository'

export interface Sector {
    id: number
    tenant_id: number

    en_name: string
    ar_name?: string | null
    status: number
    created_by?: number | null
    updated_by?: number | null
    created_at: Date
    updated_at: Date
    ref_code?: string

}

export interface CreateSectorRequest {
    tenant_id: number
    en_name: string
    ar_name?: string
    status?: number
    ref_code?: string

}

export interface UpdateSectorRequest {
    tenant_id?: number
    en_name?: string
    ar_name?: string
    status?: number
    ref_code?: string

}

class SectorRepository {
    async getAll(page: number = 1, limit: number = 25, filters?: any): Promise<PaginatedResponse<Sector>> {
        const params = new URLSearchParams({
            page: page.toString(),
            limit: limit.toString(),
        })

        if (filters) {
            if (filters.search) params.append('search', filters.search)
            if (filters.status) params.append('status', filters.status)
            if (filters.sector_id) params.append('sector_id', filters.sector_id)
        }

        return apiClient.get<PaginatedResponse<Sector>>(`/sectors?${params.toString()}`)
    }

    async getById(id: number): Promise<Sector> {
        return apiClient.get<Sector>(`/sectors/${id}`)
    }

    async create(data: CreateSectorRequest): Promise<Sector> {
        return apiClient.post<Sector>('/sectors', data)
    }

    async update(id: number, data: UpdateSectorRequest): Promise<Sector> {
        return apiClient.put<Sector>(`/sectors/${id}`, data)
    }

    async delete(id: number): Promise<{ message: string }> {
        return apiClient.delete<{ message: string }>(`/sectors/${id}`)
    }

    async exportToExcel(filters?: any): Promise<Blob> {
        const params = new URLSearchParams()
        if (filters?.search) params.append('search', filters.search)
        if (filters?.status) params.append('status', filters.status)
        if (filters.sector_id) params.append('sector_id', filters.sector_id.toString())

        const baseUrl = `/sectors/export/excel`;
        const queryString = params.toString();
        const url = queryString ? `${baseUrl}?${queryString}` : baseUrl;

        return apiClient.getBlob(url, true, { showSuccessToast: true, successMessage: 'Exported Successfully' })
    }
}

export const sectorRepository = new SectorRepository()

